import { Header } from "../../components/Header"
import { useParams } from "react-router-dom";
import { Technology } from "../../components/Technology";
import { TechnologyData, getTechnology } from "../../remote/scan_data";
import { useEffect, useState } from "react";
import { ScanChildren } from "../../components/ScanChildren";
import { Box, CircularProgress, Container, Paper } from "@mui/material";

export const TreeTechnology = () => {
	const params = useParams()
	const entityId = params.entityId;

	if ( ! entityId) {
		return <CircularProgress />
	}

	const [technologyData, setTechnologyData] = useState<TechnologyData | null>(null);
	useEffect(() => {
		getTechnology(entityId, (data, resp) => {
			if (data) {
				setTechnologyData(data);
			} else {
				setTechnologyData(null);
			}
		});
	}, [setTechnologyData]);

	return (technologyData ? <>
		<Header />
		<Container>
			<Technology id={entityId} data={technologyData} hideChildren/>
			<Box margin={1}></Box>
			<ScanChildren data={technologyData.children} />
		</Container>
	</> : <CircularProgress />)
}
